import { useMemo } from 'react'
import useActiveUid from './useActiveUid'

const useIsMine = (uid: string) => {
  const myUid = useActiveUid()
  return useMemo(() => uid === myUid, [uid, myUid])
}

export default useIsMine
